import { render, staticRenderFns } from "./ownerLgsList.vue?vue&type=template&id=021809cb&scoped=true"
import script from "./ownerLgsList.vue?vue&type=script&lang=js"
export * from "./ownerLgsList.vue?vue&type=script&lang=js"
import style0 from "./ownerLgsList.vue?vue&type=style&index=0&id=021809cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021809cb",
  null
  
)

export default component.exports